module.exports = __webpack_public_path__ + "media/17 Teachers’ Day.284314c4.mp3";